import React from 'react';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  name: string;
  role: string;
  location: string;
  dark?: boolean;
}
export function TestimonialCard({
  quote,
  name,
  role,
  location,
  dark = false
}: TestimonialCardProps) {
  const initial = name.charAt(0);
  return <div className={`relative p-5 md:p-8 rounded-2xl shadow-sm border ${dark ? 'bg-navy-800 border-navy-700 text-white' : 'bg-white border-gray-100 text-navy-900'}`} data-id="element-312">
      <Quote className={`absolute top-4 right-4 md:top-6 md:right-6 w-6 h-6 md:w-8 md:h-8 opacity-10 ${dark ? 'text-optic' : 'text-terracotta'}`} data-id="element-313" />

      <p className={`text-sm md:text-lg italic mb-4 md:mb-6 relative z-10 leading-relaxed ${dark ? 'text-gray-300' : 'text-gray-700'}`} data-id="element-314">
        "{quote}"
      </p>

      <div className="flex items-center gap-3 md:gap-4" data-id="element-315">
        <div className={`w-10 h-10 md:w-12 md:h-12 rounded-full flex items-center justify-center font-display text-lg md:text-xl ${dark ? 'bg-navy-900 text-optic border border-navy-700' : 'bg-cream text-terracotta border border-gray-200'}`} data-id="element-316">
          {initial}
        </div>
        <div data-id="element-317">
          <h4 className="font-bold text-sm md:text-base" data-id="element-318">{name}</h4>
          <p className={`text-xs md:text-sm font-medium ${dark ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-319">
            {location} — {role}
          </p>
        </div>
      </div>
    </div>;
}